module.exports = __webpack_public_path__ + "static/media/activity-bgm.2aa9d35d.mp3";